module.exports = __webpack_public_path__ + "img/loan_status_reject.185d7dae.webp";